import { Types } from '@grandvisionhq/graphql';
import { mapNonPrescriptionBundleLineItem } from './non-prescription-bundle.js';
import { mapPrescriptionGlassesLineItem } from './prescription-glasses.js';

// Maps the server model to client view model (getCart queries to view cart UI)
const mapBundleProduct = (lineItemRaw, settings, intl)=>{
    switch(lineItemRaw.bundleLineItemsType){
        case Types.BundleLineItemType.PRESCRIPTION_GLASSES:
            return mapPrescriptionGlassesLineItem(lineItemRaw, settings, intl);
        case Types.BundleLineItemType.NON_PRESCRIPTION_BUNDLE:
            return mapNonPrescriptionBundleLineItem(lineItemRaw, settings, intl);
        default:
            console.error(`Encountered unsupported bundle line item type "${lineItemRaw.bundleLineItemsType}" with SKU: ${lineItemRaw.sku}`);
            return null;
    }
};

export { mapBundleProduct };
//# sourceMappingURL=bundle-product.js.map
